import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import NextLink, { LinkProps as NextLinkProps } from 'next/link'
import MUILink, { LinkProps as MUILinkProps } from '@mui/material/Link'

type LinkProps = NextLinkProps & MUILinkProps

// This component is based on https://stackoverflow.com/a/66228870/3392818
const Link = forwardRef<HTMLAnchorElement | null, LinkProps>(
  (
    {
      href,
      as,
      prefetch,
      replace,
      scroll,
      shallow,
      locale,
      children,
      ...muiProps
    },
    ref
  ) => (
    <NextLink
      href={href}
      passHref
      as={as}
      prefetch={prefetch}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
      locale={locale}
    >
      <MUILink {...muiProps} ref={ref}>
        {children}
      </MUILink>
    </NextLink>
  )
)

Link.displayName = 'Link'

Link.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  // NextLink props
  as: PropTypes.string,
  prefetch: PropTypes.bool,
  replace: PropTypes.bool,
  scroll: PropTypes.bool,
  shallow: PropTypes.bool,
  locale: PropTypes.any
}

export default Link
